import { render, staticRenderFns } from "./GroupManage.vue?vue&type=template&id=8331101e&"
import script from "./GroupManage.vue?vue&type=script&lang=js&"
export * from "./GroupManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports